export const AffiliationStep = {
    default: 1,
    detail: 2,
    result: 3
} as const;